export function getUniqueCount<T, K extends keyof T>(array: T[], key: K): number {
    return new Set(array.map(item => item[key])).size;
}

export function dedupeByLatestEffective<T extends { EffectiveStartDate: string; EffectiveEndDate: string | null }, K extends keyof T>(
    array: T[],
    key: K
): T[] {
    const byKey = new Map<T[K], T>();
    for (const item of array) {
        const existing = byKey.get(item[key]);
        if (!existing || isMoreCurrentThan(item, existing)) {
            byKey.set(item[key], item);
        }
    }
    return Array.from(byKey.values());
}

function isMoreCurrentThan<T extends { EffectiveStartDate: string; EffectiveEndDate: string | null }>(a: T, b: T): boolean {
    const aActive = a.EffectiveEndDate === null;
    const bActive = b.EffectiveEndDate === null;
    if (aActive !== bActive) return aActive;
    return a.EffectiveStartDate > b.EffectiveStartDate;
}